/** @jsx jsx */
/** @jsxfrag */
import React from 'react';
import { jsx } from '@emotion/react';
export const AppRecommendations = ({
  children
}) => jsx(React.Fragment, null, children);